import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BarChart3, Loader2 } from "lucide-react";

export default function PromoterMyPerformance() {
  const [perf, setPerf] = useState(null);
  useEffect(() => { api.get(`/promoter/me/performance`).then(({ data }) => setPerf(data)); }, []);
  if (!perf) return <div className="flex items-center gap-2 text-slate-500"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>;
  return (
    <div data-testid="promoter-performance-page">
      <h1 className="font-display text-2xl font-semibold flex items-center gap-2"><BarChart3 className="w-5 h-5" /> My Performance</h1>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Tile testId="perf-page-visited" label="Visited" value={perf.visited} />
        <Tile testId="perf-page-interested" label="Interested" value={perf.interested} accent="text-emerald-700" />
        <Tile testId="perf-page-follow-up" label="Follow-up needed" value={perf.follow_up_needed} accent="text-amber-700" />
        <Tile testId="perf-page-signed-up" label="Signed up" value={perf.signed_up} accent="text-[#1B4332] font-bold" />
        <Tile testId="perf-page-not-interested" label="Not interested" value={perf.not_interested} accent="text-rose-700" />
        <Tile testId="perf-page-tasks-assigned" label="Tasks assigned" value={perf.tasks_assigned} />
        <Tile testId="perf-page-tasks-completed" label="Tasks completed" value={perf.tasks_completed} />
        <Tile testId="perf-page-tasks-overdue" label="Tasks overdue" value={perf.tasks_overdue} accent="text-rose-700" />
      </div>
      <div className="text-xs text-slate-500 mt-3">Last activity: {perf.last_activity_at ? new Date(perf.last_activity_at).toLocaleString() : "-"}</div>
    </div>
  );
}

function Tile({ label, value, accent = "", testId }) {
  return (
    <div data-testid={testId} className="rounded-2xl border border-slate-200 bg-white p-4">
      <div className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-semibold">{label}</div>
      <div className={`font-display text-3xl mt-1 ${accent || "text-slate-900"}`}>{value ?? 0}</div>
    </div>
  );
}
